import { render, staticRenderFns } from "./KpiBarChart.vue?vue&type=template&id=4aeae7ce&"
import script from "./KpiBarChart.vue?vue&type=script&lang=js&"
export * from "./KpiBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports